export class RefreshTokenViewModel {
  AuthToken: any | undefined;
  RefreshToken: string | undefined;


}
